export default __webpack_public_path__ + "static/studio4-41a77c5cbc565c8e3d7467d3be3dc958.png";